const API_PREFIX = process.env.NODE_ENV == 'production'
  ? 'https://api.vrcast.tv'
  : process.env.NODE_ENV == 'devproduction'
    ? ' https://api.vrcast.tv'
    : '/api';

// export const TICKET_PREFIX = process.env.NODE_ENV == 'production'
//   ? 'https://ticket.vrcast.tv/'
//   : process.env.NODE_ENV == 'devproduction'
//     ? ' https://devticket.vrcast.tv/'
//     : '';

export const AUTH_URLS = {
  LOGIN: API_PREFIX + '/auth/login',
  INITIATOR_LOGIN: API_PREFIX + '/auth/initiator-login',
  LOGOUT: API_PREFIX + '/auth/logout',
  GET_USER: API_PREFIX + '/auth/current-user'
};

export const INITIATOR_URLS = {
  GET_LIST: API_PREFIX + '/initiator',
  GET_ONE: API_PREFIX + '/initiator/{0}',
  EDIT: API_PREFIX + '/initiator/{0}',
  SAVE: API_PREFIX + '/initiator'
};
export const CHANNEL_URLS = {
  GET_LIST: API_PREFIX + '/channel',
  GET_ONE: API_PREFIX + '/channel/{0}',
  EDIT: API_PREFIX + '/channel/{0}',
  SAVE: API_PREFIX + '/channel'
};

export const VIDEO_CHANNEL_URLS = {
  GET_LIST: API_PREFIX + '/video-channel',
  GET_ONE: API_PREFIX + '/video-channel/{0}',
  EDIT: API_PREFIX + '/video-channel/{0}',
  SAVE: API_PREFIX + '/video-channel'
};

export const VIDEO_URLS = {
  GET_LIST: API_PREFIX + '/video',
  GET_ONE: API_PREFIX + '/video/{0}',
  EDIT: API_PREFIX + '/video/{0}',
  SAVE: API_PREFIX + '/video'
};

export const EVENT_URLS = {
  GET_LIST: API_PREFIX + '/event',
  GET_EVENT: API_PREFIX + '/event/{0}',
  GET_RESOURCE: API_PREFIX + '/event/{0}/{1}',
  GET_STATISTIC: API_PREFIX + '/event/statistic/{0}',
  EDIT: API_PREFIX + '/event/{0}',
  DELETE: API_PREFIX + '/event/{0}',
  SAVE: API_PREFIX + '/event'
};

export const TICKET_CATEGORY_URLS = {
  GET_LIST: API_PREFIX + '/ticket-category',
  GET_LIST_BY_EVENT: API_PREFIX + '/ticket-category/event/{0}',
  GET_EVENT: API_PREFIX + '/ticket-category/{0}',
  EDIT: API_PREFIX + '/ticket-category/{0}',
  SAVE: API_PREFIX + '/ticket-category',

  GET_CAMERAS: API_PREFIX + '/camera-to-ticket-category',
  BULK_GET_CAMERAS: API_PREFIX + '/camera-to-ticket-category/get-bulk',
  BULK_SAVE_CAMERAS: API_PREFIX + '/camera-to-ticket-category/bulk',
  BULK_DEL_CAMERAS: API_PREFIX + '/camera-to-ticket-category/delete/bulk/{0}',
  DEL_CAMERA: API_PREFIX + '/camera-to-ticket-category/{0}'
};


export const TICKET_URLS = {
  GET_LIST: API_PREFIX + '/ticket',
  GET_EVENT: API_PREFIX + '/ticket/{0}',
  GET_STATISTIC: API_PREFIX + '/ticket/statistic/{0}',
  EDIT: API_PREFIX + '/ticket/{0}',
  SAVE: API_PREFIX + '/ticket',
  SAVE_BULK: API_PREFIX + '/ticket/bulk',
  COUNT: API_PREFIX + '/ticket/count'
};
export const USER_URLS = {
  GET_LIST: API_PREFIX + '/user',
  GET_LIST_BY_CATEGORY: API_PREFIX + '/user/initiator/{0}',
  GET_EVENT: API_PREFIX + '/user/{0}',
  EDIT: API_PREFIX + '/user/{0}',
  SAVE: API_PREFIX + '/user'
};

export const CAMERA_URLS = {
  GET_LIST: API_PREFIX + '/camera',
  GET_LIST_BY_EVENT: API_PREFIX + '/camera/event/{0}',
  GET_EVENT: API_PREFIX + '/camera/{0}',
  EDIT: API_PREFIX + '/camera/{0}',
  SAVE: API_PREFIX + '/camera',
  BULK_SAVE: API_PREFIX + '/camera/bulk'
};

export const PLAYER_CONFIG_URLS = {
  GET_LIST: API_PREFIX + '/player-config',
  GET_BY_CATEGORY: API_PREFIX + '/player-config/get/ticket-category/{0}',
  GET_ONE: API_PREFIX + '/player-config/{0}',
  EDIT: API_PREFIX + '/player-config/{0}',
  SAVE: API_PREFIX + '/player-config',
  BULK_SAVE: API_PREFIX + '/player-config/bulk'
};
